// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"150":"ba9de884","458":"ba9de884","565":"ba9de884"}[chunkId] + ".css";
};